/**
 * OOS Notification Modal
 * Handles the out-of-stock notification modal functionality
 */
class OOSNotificationModal {
  constructor() {
    this.modal = document.getElementById('oosNotificationModal');
    this.modalOverlay = document.getElementById('oosNotificationOverlay');

    if (!this.modal || !this.modalOverlay) {
      console.error('OOS modal elements not found');
      return;
    }

    this.modalClose = this.modal.querySelector('.oos-notification-modal__close');
    this.notificationForm = document.getElementById('oosNotificationForm');
    this.emailInput = document.getElementById('oosNotificationEmail');
    this.formContent = this.modal.querySelector('.oos-notification-form-content');
    this.successContent = this.modal.querySelector('.oos-notification-success');

    this.initializeEventListeners();
  }

  /**
   * Initialize all event listeners
   * @returns {void}
   */
  initializeEventListeners() {
    // Open modal when custom BIS trigger is clicked
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.custom-bis-trigger');
      if (trigger) {
        e.preventDefault();
        this.open();
      }
    });

    // Close modal when clicking overlay
    this.modalOverlay.addEventListener('click', () => this.close());

    // Close modal when clicking close button
    this.modalClose.addEventListener('click', () => this.close());

    // Close modal on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.hasAttribute('open')) {
        this.close();
      }
    });

    // Handle form submission
    this.notificationForm.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  /**
   * Open the modal
   * @returns {void}
   */
  open() {
    this.modal.setAttribute('open', '');
    this.modalOverlay.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');

    // Focus the email input after a brief delay to ensure modal is visible
    setTimeout(() => {
      this.emailInput.focus();

      // Set up focus trap if available
      if (window.trapFocus) {
        trapFocus(this.modal, this.emailInput);
      }
    }, 50);
  }

  /**
   * Close the modal
   * @returns {void}
   */
  close() {
    this.modal.removeAttribute('open');
    this.modalOverlay.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');

    // Reset to form view and clear input
    this.showForm();
    this.emailInput.value = '';

    // Remove focus trap
    if (window.removeTrapFocus) {
      removeTrapFocus();
    }
  }

  /**
   * Show form content and hide success message
   * @returns {void}
   */
  showForm() {
    this.formContent.style.display = 'block';
    this.successContent.style.display = 'none';
  }

  /**
   * Show success message and hide form content
   * @returns {void}
   */
  showSuccessMessage() {
    this.formContent.style.display = 'none';
    this.successContent.style.display = 'block';
  }

  /**
   * Handle form submission
   * @param {Event} e - The submit event
   * @returns {void}
   */
  handleSubmit(e) {
    e.preventDefault();

    const email = this.emailInput.value;

    if (email && email.includes('@')) {
      // Get product data from modal data attributes
      const productData = {
        variantId: this.modal.dataset.variantId,
        productId: this.modal.dataset.productId,
        productName: this.modal.dataset.productName,
        variantName: this.modal.dataset.variantName
      };

      // Send data to Klaviyo
      if (typeof klaviyo !== 'undefined') {
        klaviyo.push(['identify', { '$email': email }]);
        klaviyo.push(['track', 'Requested Back In Stock - OOS Tag', {
          variant: parseInt(productData.variantId),
          product: parseInt(productData.productId),
          productName: productData.productName,
          variantName: productData.variantName,
          platform: 'shopify',
          email: email
        }]);
      }

      // Show success message and close modal after delay
      this.showSuccessMessage();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new OOSNotificationModal();
});
